import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import styled from "styled-components";
import { DELETE_EVENT } from "../../mutation/DeleteEvent";
import { hasuraClient } from "../../apolloClient";
import { useMutation } from "@apollo/client";
import Event1 from "../../images/no-image-icon.png";
import DeleteEvent from "../Popup/DeleteEvent";

const EventTitle = styled.h3`
  font-family: Inter;
  font-size: 21px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(22, 31, 61, 1) !important;
  margin-bottom: 10px !important;
`;
const All = (props) => {
  const { data } = props;

  const history = useHistory();

  const [DeleteEventMutation] = useMutation(DELETE_EVENT, {
    client: hasuraClient,
  });

  const [modalShowD, setModalShowD] = React.useState(false);
  const [currentEventId, setCurrentEventId] = React.useState(false);

  const deleteEvent = (id) => {
    setModalShowD(false);
    DeleteEventMutation({
      variables: {
        id: id,
      },
    }).then(() => {
      props.refetch();
    });
  };

  const onClickEvent = (id) => {
    history.push(`/event-details/${id}`);
  };

  return (
    <div className="tab-content-cover">
      <ul className="post-list">
        <DeleteEvent
          deleteEventHandler={deleteEvent}
          show={modalShowD}
          onHide={() => setModalShowD(false)}
          id={currentEventId}
        />
        {!props.loading
          ? props.error
            ? "some error occurred..."
            : data?.length
            ? data.map((event) => {
                const monthNames = [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ];
                var tempDate = new Date(event.start_date_time);
                var startTime = moment(new Date(event.start_date_time)).format(
                  "hh:mm A"
                );
                tempDate =
                  tempDate.getDate() +
                  " " +
                  monthNames[tempDate.getMonth()] +
                  " • " +
                  startTime;

                let eventImage = event?.cover_photo || Event1;

                return (
                  <li>
                    <div className="post-list-box">
                      {props?.noEditDelete ? null : (
                        <div className="toggle">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                              <span></span>
                              <span></span>
                              <span></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {moment(event?.start_date_time).unix() <
                              moment().unix() ? null : (
                                <Link to={`/edit-event/${event?.id}`}>
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M13.1817 1.5C13.0085 1.5 12.8371 1.5341 12.6771 1.60035C12.5172 1.66661 12.3719 1.76371 12.2494 1.88613L11.0763 3.05922L12.9408 4.92366L14.1139 3.75057C14.2363 3.62815 14.3334 3.48281 14.3996 3.32286C14.4659 3.16291 14.5 2.99148 14.5 2.81835C14.5 2.64522 14.4659 2.47379 14.3996 2.31384C14.3334 2.15389 14.2363 2.00856 14.1139 1.88613C13.9914 1.76371 13.8461 1.66661 13.6862 1.60035C13.5262 1.5341 13.3548 1.5 13.1817 1.5ZM11.8801 5.98432L10.0157 4.11988L2.51809 11.6175L1.81893 14.1811L4.38252 13.4819L11.8801 5.98432ZM12.1031 0.214534C12.4451 0.0728986 12.8115 0 13.1817 0C13.5518 0 13.9182 0.0728987 14.2602 0.214534C14.6021 0.356169 14.9128 0.563768 15.1745 0.825476C15.4362 1.08718 15.6438 1.39788 15.7855 1.73981C15.9271 2.08175 16 2.44824 16 2.81835C16 3.18846 15.9271 3.55495 15.7855 3.89689C15.6438 4.23882 15.4362 4.54952 15.1745 4.81122L5.30235 14.6834C5.21005 14.7757 5.09527 14.8423 4.96935 14.8766L0.947354 15.9736C0.687696 16.0444 0.409999 15.9706 0.219687 15.7803C0.0293747 15.59 -0.0443716 15.3123 0.0264445 15.0526L1.12335 11.0306C1.1577 10.9047 1.2243 10.7899 1.3166 10.6977L11.1888 0.825476C11.4505 0.563768 11.7612 0.356169 12.1031 0.214534Z"
                                      fill="#989DB2"
                                    />
                                  </svg>
                                  Edit
                                </Link>
                              )}

                              <Dropdown.Item
                                onClick={() => {
                                  setCurrentEventId(event.id);
                                  setModalShowD(true);
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.04999 1.70503C6.18127 1.57375 6.35932 1.5 6.54497 1.5H9.44497C9.63062 1.5 9.80867 1.57375 9.93994 1.70503C10.0712 1.8363 10.145 2.01435 10.145 2.2V2.9L5.84497 2.89999V2.2C5.84497 2.01435 5.91872 1.8363 6.04999 1.70503ZM4.34497 2.89999V2.2C4.34497 1.61652 4.57675 1.05694 4.98933 0.644365C5.40191 0.231785 5.96149 0 6.54497 0H9.44497C10.0284 0 10.588 0.231785 11.0006 0.644365C11.4132 1.05694 11.645 1.61652 11.645 2.2V2.9L14.52 2.89999C14.9342 2.89999 15.27 3.23578 15.27 3.64999C15.27 4.06421 14.9342 4.39999 14.52 4.39999H13.82V13.8C13.82 14.3835 13.5882 14.9431 13.1756 15.3556C12.763 15.7682 12.2034 16 11.62 16H4.36997C3.78649 16 3.22691 15.7682 2.81433 15.3556C2.40175 14.9431 2.16997 14.3835 2.16997 13.8V4.39999H1.46997C1.05576 4.39999 0.719971 4.06421 0.719971 3.64999C0.719971 3.23578 1.05576 2.89999 1.46997 2.89999H4.34497ZM3.66997 13.8V4.4H12.32V13.8C12.32 13.9857 12.2462 14.1637 12.1149 14.295C11.9837 14.4263 11.8056 14.5 11.62 14.5H4.36997C4.18432 14.5 4.00627 14.4263 3.87499 14.295C3.74372 14.1637 3.66997 13.9857 3.66997 13.8ZM6.54498 6.52502C6.9592 6.52502 7.29498 6.86081 7.29498 7.27502V11.625C7.29498 12.0392 6.9592 12.375 6.54498 12.375C6.13077 12.375 5.79498 12.0392 5.79498 11.625V7.27502C5.79498 6.86081 6.13077 6.52502 6.54498 6.52502ZM10.1949 7.27502C10.1949 6.86081 9.85916 6.52502 9.44495 6.52502C9.03073 6.52502 8.69495 6.86081 8.69495 7.27502V11.625C8.69495 12.0392 9.03073 12.375 9.44495 12.375C9.85916 12.375 10.1949 12.0392 10.1949 11.625V7.27502Z"
                                    fill="#989DB2"
                                  />
                                </svg>
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                      <div
                        className="post-image"
                        onClick={() => {
                          onClickEvent(event.id);
                        }}
                      >
                        <img src={eventImage} alt="post-image" />
                      </div>
                      <div className="post-content">
                        <label>
                          {moment(event.start_date_time).unix() <
                          moment().unix()
                            ? "Published on "
                            : "Scheduled on "}
                          {tempDate}
                        </label>
                        <EventTitle
                          onClick={() => {
                            onClickEvent(event.id);
                          }}
                        >
                          {event.name}
                        </EventTitle>
                        <p
                          onClick={() => {
                            onClickEvent(event.id);
                          }}
                          style={{
                            inlineSize: "500px",
                            overflowWrap: "break-word",
                          }}
                        >
                          {event.description}
                        </p>
                        <div className="post-tag">
                          <div className="post-tag-row">
                          <p>{`${event?.is_ticket_required && event?.event_payment_type ? event?.event_payment_type : "No-ticket"} Event`}</p>
                          </div>
                          {/* <div className="post-tag-row">
                          <div className="icon">
                            <img src={Like} alt="like icon" />
                          </div>
                          <p>0 likes</p>
                        </div>
                        <div className="post-tag-row">
                          <div className="icon">
                            <img src={download} alt="like icon" />
                          </div>
                          <p>0 shared</p>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })
            : "No Data Found..."
          : "Loading..."}
      </ul>
    </div>
  );
};

export default All;
